/* global gdAlertify */
import React, { useEffect, useState } from "react";
import axiosInstance from "../config/axiosConfig";
import { formatDate } from "../utils/utils";
import GdTable from "./components/GdTable";
import MonthInput from "./components/MonthInput";

const PeriodoTurno = () => {
    const [periodos, setPeriodos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [nuevoPeriodo, setNuevoPeriodo] = useState(new Date().toISOString().slice(0, 7));
    const [notas, setNotas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPeriodos();
    }, []);

    const fetchPeriodos = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get("/turnos/periodos/lista");
            setPeriodos(response.data.turnos);
        } catch (error) {
            console.error("Error al cargar los periodos:", error);
        } finally {
            setLoading(false);
        }
    };

    const agregarNota = () => {
        setNotas(prev => [...prev, { fecha: "", turno: "3", extra: 0, nota: "" }]);
    };


    const eliminarNota = (index) => {
        setNotas(prev => prev.filter((_, i) => i !== index));
    };

    const handleNotaChange = (index, campo, valor) => {
        const nuevasNotas = [...notas];
        nuevasNotas[index][campo] = valor;
        setNotas(nuevasNotas);
    };

    const eliminarPeriodo = (periodo) => {
        gdAlertify.confirm({
            title: "Eliminar período",
            message: `¿Está seguro de eliminar el período ${periodo}? Esto borra la configuración de feriados/notas de ese mes Y TODOS los turnos ya generados para ese rango de fechas, de TODOS los pacientes (auxiliar asignado, valores, notas). Esta acción no se puede deshacer. Úsela solo para regenerar el período desde cero con "Crear nuevo periodo".`,
            onConfirm: async () => {
                try {
                    gdAlertify.showLoader();
                    const response = await axiosInstance.post("/turnos/periodos/eliminar", { periodo });
                    if (response.data.error) {
                        gdAlertify.notiError(response.data.message || "Error al eliminar el período.");
                        return;
                    }
                    gdAlertify.alertSuccess("Período eliminado.");
                    fetchPeriodos();
                } catch (error) {
                    gdAlertify.notiError("Error al eliminar el período.");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
        });
    };

    const crearPeriodo = async () => {
        const notasPorDia = notas
            .filter(({ fecha }) => fecha)
            .map(({ fecha, turno, extra, nota }) => ({
                fecha,
                turno: parseInt(turno, 10),
                extra: parseFloat(extra),
                nota
            }));

        try {
            gdAlertify.showLoader();
            const response = await axiosInstance.post("/turnos/periodos/crear", {
                periodo: nuevoPeriodo,
                notas: notasPorDia
            });
            gdAlertify.hideLoader();
            if (response.data.error) {
                gdAlertify.notiError(response.data.message || "Error al crear periodo.");
                return;
            }
            gdAlertify.alertSuccess("Periodo creado con éxito.");
            setShowModal(false);
            setNotas([]);
            fetchPeriodos();
        } catch (error) {
            gdAlertify.hideLoader();
            gdAlertify.notiError("Error al crear el periodo.");
        }
    };

    // Cálculo del rango de fechas permitidas
    const [anio, mes] = nuevoPeriodo.split("-");
    const fechaMin = new Date(anio, mes - 2, 26).toISOString().slice(0, 10); // 26 del mes anterior
    const fechaMax = new Date(anio, mes - 1, 25).toISOString().slice(0, 10); // 25 del mes actual

    const columns = [
        { title: "Usuario", name: "nombre", render: (row) => `${row.nombre || ''} ${row.apellido || ''}` },
        { title: "Período", name: "periodo" },
        // {
        //     title: "Notas asignadas",
        //     name: "notas_json",
        //     render: row => Object.keys(row.notas_json || '').length
        // }
        {
            title: "Acciones",
            name: "acciones",
            render: (row) => (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => eliminarPeriodo(row.periodo)}
                >
                    Eliminar
                </button>
            ),
        },
    ];

    return (
        <div className="container mt-4">
            <div className="card shadow p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>Periodos de Turnos</h3>
                    <button className="btn btn-primary" onClick={() => setShowModal(true)}>
                        Crear nuevo periodo
                    </button>
                </div>

                <GdTable
                    columns={columns}
                    data={periodos}
                    stickyHeader={true}
                    height={500}
                    showCsvExport={true}
                    exportFilename="periodos-turno.xlsx"
                    initialSort={[0, "desc"]}
                    loading={loading}
                />

            </div>

            {showModal && (
                <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Crear nuevo periodo de turnos</h5>
                                <button className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <label className="form-label">Mes del periodo</label>
                                <MonthInput
                                    className="form-control mb-3"
                                    value={nuevoPeriodo}
                                    onChange={(e) => setNuevoPeriodo(e.target.value)}
                                />

                                <button className="btn btn-secondary mb-3" onClick={agregarNota}>
                                    + Agregar nota masiva
                                </button>

                                {notas.length > 0 && (
                                    <div className="table-responsive">
                                        <table className="table table-bordered align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: "18%" }}>Fecha</th>
                                                    <th style={{ width: "15%" }}>Turno</th>
                                                    <th style={{ width: "15%" }}>Extra (%)</th>
                                                    <th>Nota</th>
                                                    <th style={{ width: "5%" }}>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {notas.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={item.fecha}
                                                                min={fechaMin}
                                                                max={fechaMax}
                                                                onChange={(e) =>
                                                                    handleNotaChange(index, "fecha", e.target.value)
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-select"
                                                                value={item.turno}
                                                                onChange={(e) =>
                                                                    handleNotaChange(index, "turno", e.target.value)
                                                                }
                                                            >
                                                                <option value="1">Día</option>
                                                                <option value="2">Noche</option>
                                                                <option value="3">Ambos</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="1"
                                                                max="100"
                                                                value={item.extra}
                                                                onChange={(e) =>
                                                                    handleNotaChange(index, "extra", e.target.value)
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.nota}
                                                                onChange={(e) =>
                                                                    handleNotaChange(index, "nota", e.target.value)
                                                                }
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => eliminarNota(index)}
                                                            >
                                                                ×
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Cancelar
                                </button>
                                <button className="btn btn-primary" onClick={crearPeriodo}>
                                    Crear periodo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PeriodoTurno;
